// @flow
import React from 'react';
import useSelfEnrollment from '../../../../../hooks/useSelfEnrollment';

import styles from './styles.module.scss';

const OrganizationDisplay = () => {
  const { entityData } = useSelfEnrollment();
  const organizationName = entityData?.organizationName ?? '';

  return <div className={styles.organizationName}>{organizationName}</div>;
};

export default OrganizationDisplay;
